module.exports = __webpack_public_path__ + "img/vtc.8a432efa.svg";